import React, { useState } from "react";
import { ButtonDemo ,Error} from "../../DesignComponent/DesignComponents";
import { Font } from "../../../theme/Font";
import { Color } from "../../../theme/Color";
import { useHistory } from "react-router-dom";
import { isValidEmail } from "../../../utils/validation";
import axios from "axios";
import styled from "styled-components";

const BlogAccess = ({singlepostdata,ipAddress, getSpreadsheetData }) => {
  const [FullName, setFullName] = useState("");
  const [Email, setEmail] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setEmailError("");
    const url =
      "https://staging2.theleansuite.com/wp-json/custom/v1/apollo-newsletter";

    if (!FullName) {
      setNameError("Full Name is required.");
    }

    if (!Email) {
      setEmailError("Email Address is required.");
    } else if (!isValidEmail(Email)) {
      setEmailError("Please enter a valid email address.");
    }

    if (FullName && Email && !nameError && !emailError) {
      setLoading(true);
      const data = {
        name: FullName,
        email: Email,
      };
      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      await appendSpreadsheet();
      if (response.status == 200) {
        // handleClose();
        // navigate.push("/newsletter-success");
      }
    }
  };

  const appendSpreadsheet = async () => {
    const newRow = {
      IP_Address: ipAddress,
      Full_Name: FullName,
      Email: Email,
      Blog_Title: singlepostdata.title,
    };
    try {
        let response = await axios.post(
        "https://theleansuite.com/api/blog-signup",
        // "https://theleansuite.com/api/add-row",
        newRow
      );
      if (response.status === 200) {
        await getSpreadsheetData();
      }
    } catch (error) {
      console.error("Error adding row:", error);
    }
  };
  return (
    <AccessPopup>
      <Title>Dive deeper into our latest blog post</Title>
      <SubTitle>
        Sign up now and get instant access to the full article, plus weekly updates and insights on game-changing Lean methodologies and cutting-edge continuous improvement strategies.
      </SubTitle>
      <form>
        <div className="mb-3 text-start">
          <Tit
            className="text-muted mb-"
            style={{
              textAlign: "start",
              display: "block",
            }}
          >
            First name and last name:
          </Tit>
          <Input
            type="text"
            value={FullName}
            onChange={(e) =>
              setFullName(e.target.value)
            }
          />
          {nameError && <Error>{nameError}</Error>}
        </div>
        <div className="mb-3 text-start">
          <Tit
            className="text-muted mb-"
            style={{
              textAlign: "start",
              display: "block",
            }}
          >
            Email address:
          </Tit>
          <Input
            type="text"
            value={Email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {emailError && <Error>{emailError}</Error>}
        </div>
        <ButtonDemo
          className="rounded-1 w-100"
          onClick={(e) => handleSubmit(e)}
          type="submit"
          disabled={loading}
        >
          {loading ? "Processing..." : "Continue reading"}
        </ButtonDemo>
      </form>
    </AccessPopup>
  );
};

export default BlogAccess;

const AccessPopup = styled.div`
    position: sticky;
    top: 160px;
    z-index: 9997;
    width: 100%;
    border: 1px solid #0000002d;
    border-radius: 5px;
    background: rgb(244 244 244);
    padding: 35px 80px;
    text-align: center;
}
`;
const Tit = styled.label`
  text-align: start;
  justify-content:start
  color: #687C82;
  font-family: ${Font.basel};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  // margin-top:23px;
  text-align: start;
  margin-bottom:5px
`;
const Input = styled.input`
  width: 100%;
  // height: 6vh;
  background-color: ${Color.white};
  border: 1px solid lightgrey;
  // margin-top: 8px;
  border-radius: 2px;
  padding: 10px;
  &:focus-visible {
    outline: none;
  }
`;
const SubTitle=styled.p`
font-size: 18px !important;
margin-top:0px !important;
margin-bottom:15px !importanat;
`
const Title=styled.h2`
font-size: 29px !important;
margin-top:0px !important;
margin-bottom:15px !importanat;
`
